export default class ReservationStatus {
  constructor(data) {
    this._id = data.id;
    this._name = data.name;
  }

  get id() {
    return this._id;
  }

  get name() {
    return this._name;
  }

  get canBeSet() {
    return this.id !== 0 && this.id !== 2;
  }
}
